let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c2fH1")).then(() => parcelRequire('bWtDk'));